import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {Router} from '@angular/router';
import { environment } from "src/environments/environment";
@Component({
    selector: 'app-register-success',
    templateUrl: './register-success.component.html',
    styleUrls: ['./register-success.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class RegisterSuccessComponent implements OnInit {
  @Input() isMobile!: boolean;
   public environment = environment;
  constructor(
      public projectTitle: Title,
      public router: Router
  ) { }

  ngOnInit(): void {
  }

}
